import React from 'react';

import CountWords from '@/src/components/CountWords/CountWords';
import ItemWrapper from '@/src/constrains/SalesChannelPreviewPageComponents/OverwriteItemWrapper';
import Section from '@/src/constrains/SalesChannelPreviewPageComponents/SectionContainer';
import ErrorProcessingHOC from 'src/constrains/SalesChannelPreviewPageComponents/ErrorProcessingHOC';

import { useDispatch } from 'react-redux';

import {
  EnumCollapseId,
  getCollapseOpenStatus,
  getCollapseValidationMsgDisplay,
  getCurrencySelector,
  getSubmitStamp,
  onCollapseOpen,
  onErrorChange,
  onCurrencySelectorChange,
} from 'src/pages/SalesChannelContentEditor/SalesChannelFooter/slice';

import { Input } from '@/src/components/Antd';
import { useI18n } from 'src/hooks/useRouterChange';
import {
  errKey,
  validateCurrencySelector,
} from 'src/pages/SalesChannelContentEditor/SalesChannelFooter/tools';
import { store } from 'src/store';
import {
  generalValuePickerAccordingLanguage,
  getI18nFromGeneral,
  i18nGet,
} from 'src/tools/tools';

const CurrencySelector = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const d = useDispatch();
  const { data, specificError } = props;
  const titleErr = specificError[errKey.currencySelectorTitle];
  const { title } = data || {};
  return (
    <React.Fragment>
      <Section bottomBorder>
        <ItemWrapper
          title={`${getI18n(
            'salesChannelContent.index.currencySelectorTitle',
          )}*`}
          rightPart={
            <CountWords count={(title || '').length} allCount={100} />
          }>
          <Input
            maxLength={100}
            error={(titleErr || []).length > 0}
            help={(titleErr || []).join(' ')}
            size='large'
            value={title}
            onChange={(title) => {
              d(onCurrencySelectorChange(title));
            }}
          />
        </ItemWrapper>
      </Section>
    </React.Fragment>
  );
};

export default ErrorProcessingHOC(CurrencySelector, {
  getCollapseOpenStatus,
  onCollapseOpen,
  id: EnumCollapseId.currencySelector,
  getContent: getCurrencySelector,
  title: getI18nFromGeneral('general.hOCTitle.currencySelector'),
  getErrorDisplay: getCollapseValidationMsgDisplay,
  onErrorChange,
  expandOffset: 0,
  getSubmitStamp,
  validation: (x, validationProps) => {
    const { isPrimary } = validationProps || {};
    return validateCurrencySelector(x, isPrimary);
  },
  headerProps: {
    dotsFunction: [
      {
        onClick: () => {
          const text = generalValuePickerAccordingLanguage({
            cn: '货币',
            hk: '貨幣',
            gb: 'Currency',
          });
          store.dispatch(onCurrencySelectorChange(text));
        },
        key: 'Reset',
        body: getI18nFromGeneral('general.hOCTitle.reset'),
        isDangerous: true,
      },
    ],
    hasDots: true,
    hideDotsWhenNotPrimary: true,
  },
});
